<template>
  <div>
    <div
      v-for="(childMenu) in menu.children"
      :key="childMenu.name"
    >
      <div v-if="childMenu.children && childMenu.children.length" class="level-two-title">{{ childMenu.title }}</div>
      <div v-if="childMenu.children && childMenu.children.length" class="row">
        <MenuItem :base-path="childMenu.path" :menu="childMenu" />
      </div>
      <div v-else-if="!childMenu.hide" class="row">
        <app-link class="link-item" :class="isActive(childMenu)?'active':''" :to="childMenu.path" :params="childMenu.params" :menu="childMenu">{{ childMenu.title }}</app-link>
      </div>
    </div>
  </div>
</template>

<script>
import AppLink from './link.vue'

export default {
  name: 'MenuItem',
  components: {
    AppLink
  },
  props: {
    menu: {
      type: Object,
      default: () => {}
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  methods: {
    isActive(menu) {
      return this.$route.name === menu.name
    }
  }
}
</script>

<style lang="scss" scoped>
.level-two-title {
  font-size: 16px;
  font-weight: 500;
  color: #616366;
  margin: 19px 0 11px 32px;
}
.link-item {
  // width: 164px;
  // height: 32px;
  width: 204px;
  min-height: 32px;

  margin: 2px 0 0 16px;
  border-radius: 4px;
  display: inline-block;
  padding-left: 16px;
  font-size: 13px;
  font-weight: 400;
  color: #616366;
  transition: background-color .1s ease-out;
  cursor: pointer;
  &:hover {
    color: #FFFFFF;
    font-weight: 500;
    background-color: #3b6dff;
    box-shadow: 0px 3px 3px 1px #DDEDFF;
  }
  &.active{
    color: #FFFFFF;
    font-weight: 500;
    background-color: #3b6dff;
    box-shadow: 0px 3px 3px 1px #DDEDFF;
  }
  &.active{
    color: #FFFFFF;
    font-weight: 500;
    background-color: $main-color;
    box-shadow: 0px 3px 3px 1px rgba(130, 97, 247, 0.17);
  }
}
</style>
